export {
  default as SecondFactorAuthentication
} from './SecondFactorAuthentication'



// WEBPACK FOOTER //
// ./src/features/Checkout/SecondFactorAuthenticaton/index.js